var _style, _g, _path, _path2, _polygon, _polygon2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBomb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 33.5",
    style: {
      enableBackground: "new 0 0 20 33.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\r\n\t.st2{fill:#FF0000;}\r\n\t.st3{fill:#FBB03B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_17_",
    cx: 10,
    cy: 23.5,
    r: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1_",
    className: "st0",
    d: "M4,23.5c0-3.3,2.7-6,6-6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st1",
    d: "M14.4,16.8C20,13.3,18,6.6,12.2,8.4c-3.4,1.1-7.1,1.5-7.4-3"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_32_",
    className: "st2",
    points: "3.8,4 4.4,0 5.7,3.8 10.2,3 6.7,5.5 8.4,8.2 5.1,6.9 2.6,10.8 3.3,5.9 0,3.9 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_33_",
    className: "st3",
    points: "4.9,4 7,1.8 6.2,4.6 9.3,6.1 6.1,6.1 5.9,8.5 4.4,6.3 1.2,7.6 3.8,4.9 2.6,2.3 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBomb);
export default __webpack_public_path__ + "static/media/bomb.011d1f3b179ad6b35cf7b0032c31cc1c.svg";
export { ForwardRef as ReactComponent };